import React, { ChangeEvent, FunctionComponent } from 'react';
import financeProductTabsStyles from './financeProductTabsStyles';
import { Tab, Tabs, Typography } from '@material-ui/core';
import useIsMobile from '../../../../../../common/react/useIsMobile';
import Translation from '../../../../../../gqlCommon/components/translation/Translation';

export interface IFinanceProductTabs {
  disabled?: boolean;
  isCash: boolean;
  onChange: (event: ChangeEvent<unknown>, value: string) => void;
  financeDisabled?: boolean;
}
const FinanceProductTabs: FunctionComponent<IFinanceProductTabs> = ({
  onChange,
  isCash,
  disabled,
  financeDisabled,
}) => {
  const style = financeProductTabsStyles();
  const isMobile = useIsMobile();

  return (
    <Tabs
      value={isCash ? 'cash' : 'finance'}
      onChange={onChange}
      indicatorColor="primary"
      centered={!isCash && isMobile}
      classes={{ root: style.tabs, indicator: style.indicator }}
      data-test="container:finance_product_tabs"
    >
      <Tab
        value={'cash'}
        data-test={'button:finance_product_tabs:cash'}
        classes={{ root: style.item, selected: style.selectedItem }}
        aria-selected={isCash}
        disabled={disabled}
        label={
          <Typography variant="subtitle1" className={style.tabLabel}>
            <Translation id="trans__configurator__customise_page_sticky_footer__cash_toggle" />
          </Typography>
        }
      />
      <Tab
        value={'finance'}
        data-test={'button:finance_product_tabs:finance'}
        classes={{ root: style.item, selected: style.selectedItem }}
        aria-selected={!isCash}
        disabled={disabled || financeDisabled}
        label={
          <Typography variant="subtitle1" className={style.tabLabel}>
            <Translation id="trans__configurator__customise_page_sticky_footer__finance_toggle" />
          </Typography>
        }
      />
    </Tabs>
  );
};

export default FinanceProductTabs;
